import { ArrowsRightLeftIcon } from "@heroicons/react/24/solid";
import LogoutIcon from "./LogoutIcon";
import { IconTypes } from "./types";

export const BookingSvg = ({ className = `  ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9 2H15.07C17.78 2 19.97 3.07 20 5.79V20.97C20 21.14 19.96 21.31 19.88 21.46C19.75 21.7 19.53 21.88 19.26 21.96C19 22.04 18.71 22 18.47 21.86L11.99 18.62L5.5 21.86C5.351 21.939 5.18 21.99 5.01 21.99C4.45 21.99 4 21.53 4 20.97V5.79C4 3.07 6.2 2 8.9 2ZM8.22 9.62H15.75C16.18 9.62 16.53 9.269 16.53 8.83C16.53 8.39 16.18 8.04 15.75 8.04H8.22C7.79 8.04 7.44 8.39 7.44 8.83C7.44 9.269 7.79 9.62 8.22 9.62Z"
      />
    </svg>
  );
};

export const SpecialZoneSvg = ({
  width = "25",
  height = "25",
  className = ` `,
}: Partial<IconTypes>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 92 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M90.75 73.832L82.9375 19.102C82.582 16.684 80.5 14.8715 78.0625 14.8715H62.3745C60.9175 7.1645 54.144 1.3285 46.0195 1.3285C37.895 1.3285 31.1245 7.1605 29.6645 14.8715H13.9765C11.539 14.8715 9.4335 16.684 9.1015 19.102L1.289 73.832C1.24603 74.0625 1.24603 74.289 1.24603 74.5195C1.24603 77.25 3.45303 79.457 6.18353 79.457H73.1215C73.7036 79.457 74.1645 79 74.1645 78.414C74.1645 77.832 73.7075 77.371 73.1215 77.371L6.14453 77.3749C4.58203 77.3749 3.28903 76.1054 3.28903 74.5194C3.28903 74.3749 3.28903 74.2499 3.30856 74.1249L11.1211 19.3949C11.3281 18.0004 12.5391 16.9574 13.9336 16.9574H29.3716C29.352 17.3128 29.3091 17.6449 29.3091 18.0004C29.3091 22.0824 30.4771 26.0824 32.6646 29.5204L42.7696 45.4154C43.4571 46.5209 44.6641 47.1654 45.9766 47.1654C47.2891 47.1654 48.4766 46.4974 49.1836 45.4154L59.2886 29.5204C61.4761 26.0829 62.6441 22.0829 62.6441 18.0004C62.6441 17.6449 62.6245 17.3129 62.5816 16.9574H78.0196C79.4376 16.9574 80.6446 18.0004 80.8321 19.3949L88.6446 74.1019C88.6446 74.2269 88.6641 74.3714 88.6641 74.4964C88.6641 76.0589 87.3946 77.3519 85.8086 77.3519H81.3711C80.7891 77.3519 80.3281 77.8089 80.3281 78.3949C80.3281 78.9769 80.7851 79.4379 81.3711 79.4379H85.8086C88.5391 79.4379 90.7461 77.2309 90.7461 74.5004C90.7461 74.2699 90.7461 74.0434 90.7031 73.8129L90.75 73.832ZM46 26.332C41.3945 26.332 37.668 22.6015 37.668 18C37.668 13.3945 41.3985 9.668 46 9.668C50.6055 9.668 54.332 13.3985 54.332 18C54.332 22.6055 50.6015 26.332 46 26.332Z" />
      <path d="M75.395 20.082H65.688C65.52 22.3515 65.0005 24.582 64.2075 26.6875C64.5395 26.707 64.852 26.7305 65.188 26.7305C67.0005 26.7734 68.8325 26.5859 70.6255 26.8125C74.2075 27.293 77.2935 29.832 78.9575 33.043L77.4575 21.898C77.3325 20.855 76.438 20.0855 75.395 20.0855L75.395 20.082Z" />
      <path d="M28.293 53.293C30.3125 52.168 32.793 52.125 35.0625 52.586C37.332 53.043 39.4805 53.961 41.6875 54.711C43.875 55.461 46.207 56.043 48.5 55.754C50.6055 55.504 52.6055 54.504 54.082 52.9845C55.9765 51.0665 56.8945 47.84 55.289 45.6915C54.832 45.1094 54.246 44.6485 53.582 44.336L51.832 47.086C50.5625 49.086 48.375 50.293 46 50.293C43.625 50.293 41.4375 49.086 40.168 47.086L37.4805 42.879C33.8555 42.5665 30.1875 41.6095 27.4605 39.2345C26.0855 38.0665 25.0035 36.5665 23.48 35.59C20.273 33.508 16.0855 34.258 12.355 35.0704L7.437 71.9024C7.26903 73.1524 8.2495 74.2579 9.4995 74.2579H36.5815C36.894 70.9454 35.437 68.0274 32.8745 65.9259C31.519 64.8204 29.9175 64.0704 28.4565 63.0939C27.019 62.1135 25.687 60.7814 25.312 59.0744C24.812 56.8049 26.2495 54.4064 28.2925 53.3049L28.293 53.293Z" />
      <path d="M71.957 58.98C70.5 57.812 70 54.8355 67.4375 55.187C63.3555 55.7495 66.7695 61.312 62.5 63.0815C61.125 63.644 60.0195 64.437 60.0195 66.062C60.0195 69.187 63.6015 70.562 65.9765 69.2925C67.246 68.605 67.7265 67.437 69.082 66.73C71.3125 65.5425 74.75 67.355 76.8515 65.7925C78.539 64.562 78.789 61.8745 77.164 60.5855C75.6835 59.355 73.4335 60.2105 71.9335 59.0035L71.957 58.98Z" />
    </svg>
  );
};

export const CitiesSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.75971 0H12.7039V20.4799H18.2719V16.0001C16.0639 15.6801 14.3999 14.208 14.3999 12.448C14.3999 11.456 14.9119 10.5599 15.7439 9.92005C15.776 7.424 17.3119 5.40803 19.1999 5.40803C21.088 5.40803 22.6239 7.424 22.656 9.92005C23.4881 10.5601 24 11.4561 24 12.448C24 14.208 22.336 15.68 20.128 16.0001V20.4799H22.2721V22.5279H0V20.4799H1.75999V0L1.75971 0ZM3.58367 2.304H6.3676V5.312H3.58367V2.304ZM8.06351 14.976H10.8474V17.984H8.06351V14.976ZM8.06351 10.752H10.8474V13.76H8.06351V10.752ZM8.06351 6.52799H10.8474V9.53599H8.06351V6.52799ZM3.58367 14.976H6.3676V17.984H3.58367V14.976ZM3.58367 10.752H6.3676V13.76H3.58367V10.752ZM3.58367 6.52799H6.3676V9.53599H3.58367V6.52799ZM8.06351 2.304H10.8474V5.312H8.06351V2.304Z"
      />
    </svg>
  );
};

export const PacksSvg = ({ className = `` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M17 87.3996L46.7 97.4996V58.7996L15 48.0996V84.6996C15 85.8996 15.8 86.9996 17 87.3996Z" />
      <path d="M49.1001 31.9L18.6001 42.2L50.0001 52.9L81.4001 42.2L50.9001 31.9C50.3001 31.7 49.7001 31.7 49.1001 31.9Z" />
      <path d="M53.3 58.7996V97.4996L83 87.3996C84.2 86.9996 84.9001 85.8996 84.9001 84.6996V48.0996L53.3 58.7996Z" />
      <path d="M50 21.4C52.1 21.4 53.7999 19.7 53.7999 17.6V6.3C53.7999 4.2 52.1 2.5 50 2.5C47.9 2.5 46.2 4.2 46.2 6.3V17.5C46.2 19.7 47.9 21.4 50 21.4Z" />
      <path d="M64.5999 25.5995C65.1999 25.9995 65.8999 26.1995 66.5999 26.1995C67.8999 26.1995 69.0999 25.5995 69.7999 24.3995L75.7999 14.8995C76.8999 13.0995 76.3999 10.6995 74.5999 9.59953C72.7999 8.49953 70.3999 8.99953 69.2999 10.7995L63.2999 20.2995C62.2999 22.0995 62.7999 24.4995 64.5999 25.5995Z" />
      <path d="M30.0999 24.3995C30.7999 25.5995 32.0999 26.1995 33.2999 26.1995C33.9999 26.1995 34.6999 25.9995 35.2999 25.5995C37.0999 24.4995 37.5999 22.0995 36.4999 20.2995L30.4999 10.7995C29.3999 8.99953 26.9999 8.49953 25.1999 9.59953C23.3999 10.6995 22.8999 13.0995 23.9999 14.8995L30.0999 24.3995Z" />
    </svg>
  );
};

export const NotificationsSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 71 77"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.25234 59.7C3.75234 61.2 5.65234 62 7.75234 62H30.0523H40.5523H62.8523C64.9523 62 66.8523 61.2 68.3523 59.7C71.4523 56.6 71.3523 51.5 68.0523 48.5L65.5523 46.3C63.9523 44.8 63.0523 42.8 63.0523 40.6C63.0523 40.6 63.0523 35 63.0523 28.4C63.0523 15.4 53.0523 0 36.0523 0H34.5523C17.5523 0 7.55234 15.3 7.55234 28.4C7.55234 35 7.55234 40.6 7.55234 40.6C7.55234 42.8 6.65234 44.9 5.05234 46.3L2.55234 48.5C-0.747657 51.5 -0.847656 56.6 2.25234 59.7Z"
        // fill="black"
      />
      <path
        d="M35.2524 77C41.0524 77 45.7524 72.3 45.7524 66.5H24.7524C24.7524 72.3 29.4524 77 35.2524 77Z"
        // fill="black"
      />
    </svg>
  );
};

export const MessagesWhatsappSvg = ({
  className = ` `,
}: Partial<IconTypes>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
    >
      <path d="M13.95 4.24C11.86 1 7.58.04 4.27 2.05C1.04 4.06 0 8.44 2.09 11.67l.17.26l-.7 2.62l2.62-.7l.26.17c1.13.61 2.36.96 3.58.96c1.31 0 2.62-.35 3.75-1.05c3.23-2.1 4.19-6.39 2.18-9.71Zm-1.83 6.74c-.35.52-.79.87-1.4.96c-.35 0-.79.17-2.53-.52c-1.48-.7-2.71-1.84-3.58-3.15c-.52-.61-.79-1.4-.87-2.19c0-.7.26-1.31.7-1.75c.17-.17.35-.26.52-.26h.44c.17 0 .35 0 .44.35c.17.44.61 1.49.61 1.58c.09.09.05.76-.35 1.14c-.22.25-.26.26-.17.44c.35.52.79 1.05 1.22 1.49c.52.44 1.05.79 1.66 1.05c.17.09.35.09.44-.09c.09-.17.52-.61.7-.79c.17-.17.26-.17.44-.09l1.4.7c.17.09.35.17.44.26c.09.26.09.61-.09.87Z"></path>
    </svg>
  );
};

export const OffersSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3991 9.146L21.1193 9.866C21.6895 10.426 21.9996 11.186 21.9996 11.986C22.0096 12.786 21.6995 13.547 21.1393 14.116C21.1327 14.1233 21.126 14.1298 21.1193 14.1362C21.116 14.1394 21.1127 14.1427 21.1093 14.146L20.3991 14.856C20.119 15.136 19.9589 15.516 19.9589 15.917V16.946C19.9589 18.606 18.6084 19.957 16.9478 19.957H15.9174C15.5173 19.957 15.1372 20.116 14.8571 20.396L14.1368 21.116C13.5466 21.707 12.7763 21.996 12.006 21.996C11.2357 21.996 10.4655 21.707 9.87525 21.127L9.14498 20.396C8.86488 20.116 8.48474 19.957 8.0846 19.957H7.05423C5.39362 19.957 4.04313 18.606 4.04313 16.946V15.917C4.04313 15.516 3.88308 15.136 3.60298 14.846L2.88271 14.136C1.71229 12.967 1.70229 11.056 2.87271 9.877L3.60298 9.146C3.88308 8.866 4.04313 8.486 4.04313 8.076V7.056C4.04313 5.396 5.39362 4.047 7.05423 4.047H8.0846C8.48474 4.047 8.86488 3.886 9.14498 3.606L9.86524 2.886C11.0357 1.707 12.9464 1.707 14.1268 2.877L14.8571 3.606C15.1372 3.886 15.5173 4.047 15.9174 4.047H16.9478C18.6084 4.047 19.9589 5.396 19.9589 7.056V8.087C19.9589 8.486 20.119 8.866 20.3991 9.146ZM9.42509 15.446C9.66517 15.446 9.88525 15.356 10.0453 15.186L15.1872 10.047C15.5273 9.707 15.5273 9.146 15.1872 8.806C14.8471 8.467 14.2969 8.467 13.9567 8.806L8.81486 13.946C8.47474 14.286 8.47474 14.846 8.81486 15.186C8.97492 15.356 9.195 15.446 9.42509 15.446ZM13.6966 14.566C13.6966 15.056 14.0868 15.446 14.577 15.446C15.0571 15.446 15.4473 15.056 15.4473 14.566C15.4473 14.087 15.0571 13.696 14.577 13.696C14.0868 13.696 13.6966 14.087 13.6966 14.566ZM9.43509 8.556C9.91526 8.556 10.3054 8.946 10.3054 9.426C10.3054 9.917 9.91526 10.306 9.43509 10.306C8.95492 10.306 8.55477 9.917 8.55477 9.426C8.55477 8.946 8.95492 8.556 9.43509 8.556Z"
      />
    </svg>
  );
};
export const DriversSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <g>
          <path d="M128,113.7c26.7,0,48.4-23.3,48.4-51.8c0-28.6-21.7-51.8-48.4-51.8c-26.7,0-48.4,23.3-48.4,51.8C79.6,90.4,101.3,113.7,128,113.7z" />
          <path d="M122.4,189.4L167,126c-9.7-2.5-23.1-5.1-38.8-5.1c-1.1,0-28.5-2.2-56.9,10.9c0,0-3.6,0.4-10.7,11.3c-10.8,17.6-27.5,43.3-32.4,51.9c-3.4,5.6-12.1,16.9-6.5,28.8c6.2,11.8,11.5,20.8,13.5,22.3c6.4,0,18.6,0,26.8,0C61.6,225.7,80.4,192.4,122.4,189.4z" />
          <path d="M227.9,195.2c-8.2-14.1-26.6-42.8-28-45.4c-1.9-3.4-7.9-16.3-19.2-19.8c-1.2-0.4-2.8-0.9-4.6-1.4l-42.7,60.7c40.8,2.5,61,34.3,61,56.6l24.5,0c0,0,2.6,0.3,15.4-22.9C239,210.9,233.8,205.6,227.9,195.2z" />
          <path d="M128,204.4c-28.2,0-51,18.3-51,41.6c35.9,0,59.3,0,102,0C179,222.6,156.1,204.4,128,204.4z" />
        </g>
      </g>
    </svg>
  );
};

const HomeSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M9.13478 20.7733V17.7156C9.13478 16.9351 9.77217 16.3023 10.5584 16.3023H13.4326C13.8102 16.3023 14.1723 16.4512 14.4393 16.7163C14.7063 16.9813 14.8563 17.3408 14.8563 17.7156V20.7733C14.8539 21.0978 14.9821 21.4099 15.2124 21.6402C15.4427 21.8705 15.7561 22 16.0829 22H18.0438C18.9596 22.0023 19.8388 21.6428 20.4872 21.0008C21.1356 20.3588 21.5 19.487 21.5 18.5778V9.86686C21.5 9.13246 21.1721 8.43584 20.6046 7.96467L13.934 2.67587C12.7737 1.74856 11.1111 1.7785 9.98539 2.74698L3.46701 7.96467C2.87274 8.42195 2.51755 9.12064 2.5 9.86686V18.5689C2.5 20.4639 4.04738 22 5.95617 22H7.87229C8.55123 22 9.103 21.4562 9.10792 20.7822L9.13478 20.7733Z" />
    </svg>
  );
};

const ServiceCategoriesSVG = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 93 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M2.4746 0C1.1035 0 0 1.0646 0 2.3867V19.6597C1e-07 20.9818 1.1035 22.0464 2.4746 22.0464H19.5706C20.9417 22.0464 22.0472 20.9818 22.0472 19.6597V2.3867C22.0472 1.0646 20.9417 0 19.5706 0H2.4746ZM33.4026 0.00976562C32.0315 0.00976562 30.928 1.07437 30.928 2.39647V19.6605C30.928 20.9826 32.0315 22.0472 33.4026 22.0472H90.1426C91.5137 22.0472 92.6172 20.9826 92.6172 19.6605V2.39647C92.6172 1.07437 91.5137 0.00976562 90.1426 0.00976562H33.4026ZM2.4746 32.9998C1.1035 32.9998 0 34.0644 0 35.3865V52.6595C1e-07 53.9816 1.1035 55.0462 2.4746 55.0462H19.5706C20.9417 55.0462 22.0472 53.9816 22.0472 52.6595V35.3865C22.0472 34.0644 20.9417 32.9998 19.5706 32.9998H2.4746ZM33.4026 33.0095C32.0315 33.0095 30.928 34.0741 30.928 35.3962V52.6602C30.928 53.9823 32.0315 55.0469 33.4026 55.0469H90.1426C91.5137 55.0469 92.6172 53.9823 92.6172 52.6602V35.3962C92.6172 34.0741 91.5137 33.0095 90.1426 33.0095H33.4026ZM2.4746 65.9995C1.1035 65.9995 0 67.0641 0 68.3862V85.6592C1e-07 86.9813 1.1035 88.0459 2.4746 88.0459H19.5706C20.9417 88.0459 22.0472 86.9813 22.0472 85.6592V68.3862C22.0472 67.0641 20.9417 65.9995 19.5706 65.9995H2.4746ZM33.4026 66.0093C32.0315 66.0093 30.928 67.0739 30.928 68.396V85.66C30.928 86.9821 32.0315 88.0467 33.4026 88.0467H90.1426C91.5137 88.0467 92.6172 86.9821 92.6172 85.66V68.396C92.6172 67.0739 91.5137 66.0093 90.1426 66.0093H33.4026Z" />
    </svg>
  );
};

const PlaceSVG = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M17 0H1V2H17V0ZM18 10V8L17 3H1L0 8V10H1V16H11V10H15V16H17V10H18ZM9 14H3V10H9V14Z" />
    </svg>
  );
};
const UsersSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1583 8.23285C16.1583 10.5825 14.2851 12.4666 11.949 12.4666C9.61292 12.4666 7.73974 10.5825 7.73974 8.23285C7.73974 5.88227 9.61292 4 11.949 4C14.2851 4 16.1583 5.88227 16.1583 8.23285ZM11.949 20C8.51785 20 5.58809 19.456 5.58809 17.2802C5.58809 15.1034 8.49904 14.5396 11.949 14.5396C15.3802 14.5396 18.31 15.0836 18.31 17.2604C18.31 19.4362 15.399 20 11.949 20ZM17.9571 8.30922C17.9571 9.50703 17.5998 10.6229 16.973 11.5505C16.9086 11.646 16.9659 11.7748 17.0796 11.7946C17.2363 11.8216 17.3984 11.8369 17.5631 11.8414C19.2062 11.8846 20.6809 10.821 21.0883 9.21974C21.6918 6.84123 19.9198 4.7059 17.6634 4.7059C17.4181 4.7059 17.1835 4.73201 16.9551 4.77884C16.9238 4.78605 16.8907 4.80046 16.8728 4.82838C16.8513 4.8626 16.8674 4.90853 16.8889 4.93825C17.5667 5.8938 17.9571 7.05918 17.9571 8.30922ZM20.6782 13.5126C21.7823 13.7296 22.5084 14.1727 22.8093 14.8166C23.0636 15.3453 23.0636 15.9586 22.8093 16.4864C22.349 17.4851 20.8654 17.8058 20.2887 17.8886C20.1696 17.9066 20.0738 17.8031 20.0864 17.6833C20.3809 14.9157 18.0377 13.6035 17.4315 13.3018C17.4055 13.2883 17.4002 13.2676 17.4028 13.255C17.4046 13.246 17.4154 13.2316 17.4351 13.2289C18.7468 13.2046 20.1571 13.3847 20.6782 13.5126ZM6.43711 11.8413C6.60186 11.8368 6.76304 11.8224 6.92063 11.7945C7.03434 11.7747 7.09165 11.6459 7.02718 11.5504C6.4004 10.6228 6.04313 9.50694 6.04313 8.30913C6.04313 7.05909 6.43353 5.89371 7.11135 4.93816C7.13284 4.90844 7.14806 4.86251 7.12746 4.82829C7.10956 4.80127 7.07553 4.78596 7.04509 4.77875C6.81586 4.73192 6.58127 4.70581 6.33593 4.70581C4.07951 4.70581 2.30751 6.84114 2.91191 9.21965C3.31932 10.8209 4.79405 11.8845 6.43711 11.8413ZM6.59694 13.2545C6.59962 13.268 6.59425 13.2878 6.56918 13.3022C5.9621 13.6039 3.61883 14.9161 3.91342 17.6827C3.92595 17.8034 3.83104 17.9061 3.71195 17.889C3.13531 17.8061 1.65163 17.4855 1.19139 16.4867C0.936203 15.9581 0.936203 15.3457 1.19139 14.817C1.49225 14.1731 2.21752 13.73 3.32156 13.512C3.84358 13.385 5.25294 13.2049 6.5656 13.2292C6.5853 13.2319 6.59515 13.2464 6.59694 13.2545Z"
      />
    </svg>
  );
};

const EventSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.761 12.001C19.761 12.8145 20.429 13.4764 21.25 13.4764C21.664 13.4764 22 13.8093 22 14.2195V16.8958C22 19.159 20.142 21 17.858 21H6.143C3.859 21 2 19.159 2 16.8958V14.2195C2 13.8093 2.336 13.4764 2.75 13.4764C3.572 13.4764 4.24 12.8145 4.24 12.001C4.24 11.2083 3.599 10.6118 2.75 10.6118C2.551 10.6118 2.361 10.5335 2.22 10.3938C2.079 10.2541 2 10.0648 2 9.86866L2.002 7.10514C2.002 4.84201 3.86 3 6.144 3H17.856C20.14 3 21.999 4.84201 21.999 7.10514L22 9.78245C22 9.97864 21.921 10.1689 21.781 10.3076C21.64 10.4473 21.45 10.5256 21.25 10.5256C20.429 10.5256 19.761 11.1875 19.761 12.001ZM14.252 12.648L15.431 11.5105C15.636 11.3143 15.707 11.025 15.618 10.7575C15.53 10.4899 15.3 10.2997 15.022 10.261L13.393 10.0252L12.664 8.5627C12.539 8.31102 12.285 8.15446 12.002 8.15347H12C11.718 8.15347 11.464 8.31003 11.337 8.56171L10.608 10.0252L8.982 10.26C8.701 10.2997 8.471 10.4899 8.382 10.7575C8.294 11.025 8.365 11.3143 8.569 11.5105L9.748 12.648L9.47 14.2562C9.422 14.5336 9.535 14.8091 9.765 14.9746C9.895 15.0667 10.046 15.1143 10.199 15.1143C10.316 15.1143 10.434 15.0855 10.542 15.0291L12 14.2701L13.455 15.0271C13.707 15.1608 14.006 15.14 14.235 14.9736C14.466 14.8091 14.579 14.5336 14.531 14.2562L14.252 12.648Z"
      />
    </svg>
  );
};

const CategoriesSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.53988 2H7.91988C9.32988 2 10.4599 3.15 10.4599 4.561V7.97C10.4599 9.39 9.32988 10.53 7.91988 10.53H4.53988C3.13988 10.53 1.99988 9.39 1.99988 7.97V4.561C1.99988 3.15 3.13988 2 4.53988 2ZM4.53988 13.4697H7.91988C9.32988 13.4697 10.4599 14.6107 10.4599 16.0307V19.4397C10.4599 20.8497 9.32988 21.9997 7.91988 21.9997H4.53988C3.13988 21.9997 1.99988 20.8497 1.99988 19.4397V16.0307C1.99988 14.6107 3.13988 13.4697 4.53988 13.4697ZM19.46 2H16.08C14.67 2 13.54 3.15 13.54 4.561V7.97C13.54 9.39 14.67 10.53 16.08 10.53H19.46C20.86 10.53 22 9.39 22 7.97V4.561C22 3.15 20.86 2 19.46 2ZM16.08 13.4697H19.46C20.86 13.4697 22 14.6107 22 16.0307V19.4397C22 20.8497 20.86 21.9997 19.46 21.9997H16.08C14.67 21.9997 13.54 20.8497 13.54 19.4397V16.0307C13.54 14.6107 14.67 13.4697 16.08 13.4697Z"
      />
    </svg>
  );
};

const PartnersSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7044 3.51898C10.034 3.51898 9.46373 3.9848 9.30365 4.61265H14.6863C14.5263 3.9848 13.956 3.51898 13.2856 3.51898H10.7044ZM16.2071 4.61264H18.1881C20.2891 4.61264 22 6.34428 22 8.47085C22 8.47085 21.94 9.3711 21.92 10.6248C21.918 10.724 21.8699 10.8212 21.7909 10.88C21.3097 11.2354 20.8694 11.5291 20.8294 11.5493C19.1686 12.6632 17.2386 13.447 15.1826 13.8369C15.0485 13.8632 14.9165 13.7934 14.8484 13.6739C14.2721 12.6754 13.1956 12.0253 11.995 12.0253C10.8024 12.0253 9.71586 12.6683 9.12256 13.6678C9.05353 13.7853 8.92346 13.8531 8.7904 13.8278C6.75138 13.4369 4.82141 12.6541 3.17059 11.5594L2.21011 10.8911C2.13007 10.8405 2.08004 10.7493 2.08004 10.6481C2.05003 10.1316 2 8.47085 2 8.47085C2 6.34428 3.71086 4.61264 5.81191 4.61264H7.78289C7.97299 3.1443 9.2036 2 10.7044 2H13.2856C14.7864 2 16.017 3.1443 16.2071 4.61264ZM21.6598 12.8152L21.6198 12.8355C19.5988 14.1924 17.1676 15.0937 14.6163 15.4684C14.2561 15.519 13.8959 15.2861 13.7959 14.9216C13.5758 14.0912 12.8654 13.5443 12.015 13.5443H12.005H11.985C11.1346 13.5443 10.4242 14.0912 10.2041 14.9216C10.1041 15.2861 9.74387 15.519 9.38369 15.4684C6.83242 15.0937 4.4012 14.1924 2.38019 12.8355C2.37019 12.8254 2.27014 12.7646 2.1901 12.8152C2.10005 12.8659 2.10005 12.9874 2.10005 12.9874L2.17009 18.1519C2.17009 20.2785 3.87094 22 5.97199 22H18.018C20.1191 22 21.8199 20.2785 21.8199 18.1519L21.9 12.9874C21.9 12.9874 21.9 12.8659 21.8099 12.8152C21.7599 12.7849 21.6999 12.795 21.6598 12.8152ZM12.7454 17.0583C12.7454 17.4836 12.4152 17.8177 11.995 17.8177C11.5848 17.8177 11.2446 17.4836 11.2446 17.0583V15.7519C11.2446 15.3367 11.5848 14.9924 11.995 14.9924C12.4152 14.9924 12.7454 15.3367 12.7454 15.7519V17.0583Z"
      />
    </svg>
  );
};

const SettingsSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4022 13.5801C20.7599 13.7701 21.0358 14.0701 21.23 14.3701C21.6081 14.9901 21.5775 15.7501 21.2096 16.4201L20.4942 17.6201C20.1161 18.2601 19.4109 18.6601 18.6853 18.6601C18.3277 18.6601 17.9291 18.5601 17.6021 18.3601C17.3364 18.1901 17.0298 18.1301 16.7027 18.1301C15.691 18.1301 14.8428 18.9601 14.8121 19.9501C14.8121 21.1001 13.8719 22.0001 12.6967 22.0001H11.3068C10.1213 22.0001 9.18113 21.1001 9.18113 19.9501C9.16069 18.9601 8.31247 18.1301 7.30073 18.1301C6.96348 18.1301 6.6569 18.1901 6.40141 18.3601C6.07438 18.5601 5.6656 18.6601 5.31813 18.6601C4.58232 18.6601 3.87717 18.2601 3.49905 17.6201L2.7939 16.4201C2.41577 15.7701 2.39533 14.9901 2.77346 14.3701C2.93697 14.0701 3.24356 13.7701 3.59102 13.5801C3.87717 13.4401 4.06112 13.2101 4.23486 12.9401C4.74584 12.0801 4.43925 10.9501 3.57059 10.4401C2.55885 9.87011 2.23182 8.60011 2.81434 7.61011L3.49905 6.43011C4.09178 5.44011 5.35901 5.09011 6.38097 5.67011C7.27007 6.15011 8.42488 5.83011 8.94608 4.98011C9.10959 4.70011 9.20157 4.40011 9.18113 4.10011C9.16069 3.71011 9.27311 3.34011 9.46728 3.04011C9.8454 2.42011 10.5301 2.02011 11.2761 2.00011H12.7171C13.4734 2.00011 14.1581 2.42011 14.5362 3.04011C14.7201 3.34011 14.8428 3.71011 14.8121 4.10011C14.7917 4.40011 14.8837 4.70011 15.0472 4.98011C15.5684 5.83011 16.7232 6.15011 17.6225 5.67011C18.6342 5.09011 19.9117 5.44011 20.4942 6.43011L21.1789 7.61011C21.7716 8.60011 21.4446 9.87011 20.4227 10.4401C19.554 10.9501 19.2474 12.0801 19.7686 12.9401C19.9321 13.2101 20.1161 13.4401 20.4022 13.5801ZM9.10959 12.0101C9.10959 13.5801 10.4075 14.8301 12.012 14.8301C13.6164 14.8301 14.8837 13.5801 14.8837 12.0101C14.8837 10.4401 13.6164 9.18011 12.012 9.18011C10.4075 9.18011 9.10959 10.4401 9.10959 12.0101Z"
      />
    </svg>
  );
};

const NewsletterSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.9394 3C18.2804 3 19.5704 3.53 20.5194 4.481C21.4694 5.43 22.0004 6.71 22.0004 8.05V15.95C22.0004 18.74 19.7304 21 16.9394 21H7.06043C4.26943 21 2.00043 18.74 2.00043 15.95V8.05C2.00043 5.26 4.25943 3 7.06043 3H16.9394ZM18.5304 9.54L18.6104 9.46C18.8494 9.17 18.8494 8.75 18.5994 8.46C18.4604 8.311 18.2694 8.22 18.0704 8.2C17.8604 8.189 17.6604 8.26 17.5094 8.4L13.0004 12C12.4204 12.481 11.5894 12.481 11.0004 12L6.50043 8.4C6.18943 8.17 5.75943 8.2 5.50043 8.47C5.23043 8.74 5.20043 9.17 5.42943 9.47L5.56043 9.6L10.1104 13.15C10.6704 13.59 11.3494 13.83 12.0604 13.83C12.7694 13.83 13.4604 13.59 14.0194 13.15L18.5304 9.54Z"
      />
    </svg>
  );
};

const PayoutsSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M21 12V7H5a2 2 0 0 1 0-4h14v4" />
      <path d="M3 5v14a2 2 0 0 0 2 2h16v-5" />
      <path d="M18 12a2 2 0 0 0 0 4h4v-4Z" />
    </svg>
  );
};

const TranslationsSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      height="19"
      width="19"
      className={className}
    >
      <path d="M478.33 433.6l-90-218a22 22 0 00-40.67 0l-90 218a22 22 0 1040.67 16.79L316.66 406h102.67l18.33 44.39A22 22 0 00458 464a22 22 0 0020.32-30.4zM334.83 362L368 281.65 401.17 362zM267.84 342.92a22 22 0 00-4.89-30.7c-.2-.15-15-11.13-36.49-34.73 39.65-53.68 62.11-114.75 71.27-143.49H330a22 22 0 000-44H214V70a22 22 0 00-44 0v20H54a22 22 0 000 44h197.25c-9.52 26.95-27.05 69.5-53.79 108.36-31.41-41.68-43.08-68.65-43.17-68.87a22 22 0 00-40.58 17c.58 1.38 14.55 34.23 52.86 83.93.92 1.19 1.83 2.35 2.74 3.51-39.24 44.35-77.74 71.86-93.85 80.74a22 22 0 1021.07 38.63c2.16-1.18 48.6-26.89 101.63-85.59 22.52 24.08 38 35.44 38.93 36.1a22 22 0 0030.75-4.9z" />
    </svg>
  );
};

const InspectorsSvg = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.294 7.29105C17.294 10.2281 14.9391 12.5831 12 12.5831C9.0619 12.5831 6.70601 10.2281 6.70601 7.29105C6.70601 4.35402 9.0619 2 12 2C14.9391 2 17.294 4.35402 17.294 7.29105ZM12 22C7.66237 22 4 21.295 4 18.575C4 15.8539 7.68538 15.1739 12 15.1739C16.3386 15.1739 20 15.8789 20 18.599C20 21.32 16.3146 22 12 22Z"
      />
    </svg>
  );
};

const AdvertisementSVG = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 96 81"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <g>
          <path d="M12.2 21.4902C11.88 21.4889 11.563 21.5508 11.267 21.6723C10.971 21.7939 10.702 21.9726 10.4753 22.1984C10.2486 22.4242 10.0687 22.6925 9.94592 22.988C9.82318 23.2835 9.76 23.6003 9.76 23.9202V26.3602H2.44C1.79287 26.3602 1.17225 26.6173 0.714659 27.0749C0.257071 27.5325 0 28.1531 0 28.8002V43.4402C0 44.0874 0.257071 44.708 0.714659 45.1656C1.17225 45.6232 1.79287 45.8802 2.44 45.8802H9.76V48.3102C9.76 48.9574 10.0171 49.578 10.4747 50.0356C10.9322 50.4932 11.5529 50.7502 12.2 50.7502H13.67L23.5 76.8902C23.7952 77.6535 24.2796 78.3292 24.9075 78.8539C25.5355 79.3787 26.2865 79.7353 27.09 79.8902C27.4184 79.963 27.7537 79.9998 28.09 80.0002C28.7247 80.0055 29.354 79.8825 29.94 79.6385C30.526 79.3945 31.0566 79.0345 31.5 78.5802L37.36 72.7702C38.0875 72.0463 38.5665 71.1102 38.7282 70.0968C38.89 69.0833 38.726 68.0446 38.26 67.1302L30.04 50.7502H36.5C37.34 50.7502 38.17 50.9202 39 51.0002V21.2402C38.16 21.3102 37.33 21.4502 36.48 21.4902H12.2Z" />
          <path d="M77.5 2.92C77.243 2.57469 76.8975 2.3052 76.5 2.14H76.36C76.1407 2.06279 75.912 2.01569 75.68 2C75.5205 2.01792 75.363 2.05141 75.21 2.1H74.93C74.5204 2.23434 74.1544 2.47607 73.87 2.8H73.8C66.201 12.0102 55.6266 18.2806 43.9 20.53V51.71C55.593 53.9588 66.1392 60.206 73.73 69.38C73.73 69.38 73.73 69.38 73.8 69.44C73.9804 69.6244 74.1857 69.7826 74.41 69.91C74.4743 69.96 74.5411 70.0067 74.61 70.05C74.9251 70.1899 75.2653 70.2648 75.61 70.27C75.8902 70.2697 76.1679 70.2189 76.43 70.12C76.8282 69.9512 77.1736 69.6783 77.43 69.33C77.4889 69.2609 77.5424 69.1873 77.59 69.11C77.8382 68.7355 77.9767 68.2991 77.99 67.85V4.41C77.9767 3.96093 77.8382 3.52451 77.59 3.15C77.566 3.07113 77.5359 2.99423 77.5 2.92Z" />
          <path d="M87.3668 44.3824L86.0619 47.1392L91.4398 49.6848L92.7447 46.928L87.3668 44.3824Z" />
          <path d="M89.0574 34.4831L88.9866 37.5322L94.935 37.6703L95.0058 34.6212L89.0574 34.4831Z" />
          <path d="M92.0764 22.4636L86.5861 24.7568L87.7616 27.5712L93.2519 25.2779L92.0764 22.4636Z" />
        </g>
      </g>
    </svg>
  );
};
const TaxisSVG = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className={`lucide lucide-car-taxi-front ${className}`}
    >
      <path d="M10 2h4" />
      <path d="m21 8-2 2-1.5-3.7A2 2 0 0 0 15.646 5H8.4a2 2 0 0 0-1.903 1.257L5 10 3 8" />
      <path d="M7 14h.01" />
      <path d="M17 14h.01" />
      <rect width="18" height="8" x="3" y="10" rx="2" />
      <path d="M5 18v2" />
      <path d="M19 18v2" />
    </svg>
  );
};
export const RidesSVG = ({ className = ` `, fill }: Partial<IconTypes>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 512 512"
      fill={fill}
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className={`lucide lucide-car-taxi-front ${className}`}
    >
      <path d="M512 96c0 50.2-59.1 125.1-84.6 155c-3.8 4.4-9.4 6.1-14.5 5L320 256c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96 43 96 96s-43 96-96 96l-276.4 0c8.7-9.9 19.3-22.6 30-36.8c6.3-8.4 12.8-17.6 19-27.2L416 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0c-53 0-96-43-96-96s43-96 96-96l39.8 0c-21-31.5-39.8-67.7-39.8-96c0-53 43-96 96-96s96 43 96 96zM117.1 489.1c-3.8 4.3-7.2 8.1-10.1 11.3l-1.8 2-.2-.2c-6 4.6-14.6 4-20-1.8C59.8 473 0 402.5 0 352c0-53 43-96 96-96s96 43 96 96c0 30-21.1 67-43.5 97.9c-10.7 14.7-21.7 28-30.8 38.5l-.6 .7zM128 352a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM416 128a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" />
    </svg>
  );
};
const RequestDriverSVG = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 90 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M0 11.1V40.8H40.9V0H11.1C5 0 0 5 0 11.1Z" />
      <path d="M0 78C0 84.2 5 89.1 11.1 89.1H40.8V48.3H0V78Z" />
      <path d="M48.3 48.3V89.2H78C84.2 89.2 89.1 84.2 89.1 78.1V48.3H48.3Z" />
      <path d="M63.2001 40.9H70.6V26H85.5V18.6H70.6V3.70001H63.2001V18.6H48.3V26H63.2001V40.9Z" />
    </svg>

    //     <svg
    //     width="25"
    //     height="25"
    //     viewBox="0 0 95 95"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //     className={className}
    //     >
    // <path d="M81.0902 13.9103C62.5432 -4.63675 32.4693 -4.63675 13.9103 13.9103C-4.63675 32.4693 -4.63675 62.5432 13.9103 81.0902C32.4693 99.6372 62.5432 99.6372 81.0902 81.0902C99.6372 62.5432 99.6372 32.4693 81.0902 13.9103ZM24.5243 38.4303H38.4303L38.4342 24.5243C38.4342 19.5321 42.5162 15.4501 47.5084 15.4501C52.5006 15.4501 56.5709 19.5321 56.5709 24.5243V38.4303H70.4769C75.4691 38.4303 79.5511 42.5123 79.5511 47.5045C79.5511 52.4967 75.4691 56.567 70.4769 56.567H56.5709V70.473C56.5709 75.4652 52.5006 79.5471 47.5084 79.5471C42.5162 79.5471 38.4342 75.4652 38.4342 70.473V56.567H24.5242C19.532 56.567 15.45 52.4967 15.45 47.5045C15.45 42.5123 19.5321 38.4303 24.5243 38.4303Z" />
    // </svg>
  );
};
const SatistiquesIconSVG = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M32 32c17.7 0 32 14.3 32 32l0 336c0 8.8 7.2 16 16 16l400 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L80 480c-44.2 0-80-35.8-80-80L0 64C0 46.3 14.3 32 32 32zM160 224c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32zm128-64l0 160c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-160c0-17.7 14.3-32 32-32s32 14.3 32 32zm64 32c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-96c0-17.7 14.3-32 32-32zM480 96l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-224c0-17.7 14.3-32 32-32s32 14.3 32 32z" />
    </svg>
  );
};
const SettingsSVG = ({ className = ` ` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 600 600"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M259.1 73.5C262.1 58.7 275.2 48 290.4 48L350.2 48C365.4 48 378.5 58.7 381.5 73.5L396 143.5C410.1 149.5 423.3 157.2 435.3 166.3L503.1 143.8C517.5 139 533.3 145 540.9 158.2L570.8 210C578.4 223.2 575.7 239.8 564.3 249.9L511 297.3C511.9 304.7 512.3 312.3 512.3 320C512.3 327.7 511.8 335.3 511 342.7L564.4 390.2C575.8 400.3 578.4 417 570.9 430.1L541 481.9C533.4 495 517.6 501.1 503.2 496.3L435.4 473.8C423.3 482.9 410.1 490.5 396.1 496.6L381.7 566.5C378.6 581.4 365.5 592 350.4 592L290.6 592C275.4 592 262.3 581.3 259.3 566.5L244.9 496.6C230.8 490.6 217.7 482.9 205.6 473.8L137.5 496.3C123.1 501.1 107.3 495.1 99.7 481.9L69.8 430.1C62.2 416.9 64.9 400.3 76.3 390.2L129.7 342.7C128.8 335.3 128.4 327.7 128.4 320C128.4 312.3 128.9 304.7 129.7 297.3L76.3 249.8C64.9 239.7 62.3 223 69.8 209.9L99.7 158.1C107.3 144.9 123.1 138.9 137.5 143.7L205.3 166.2C217.4 157.1 230.6 149.5 244.6 143.4L259.1 73.5zM320.3 400C364.5 399.8 400.2 363.9 400 319.7C399.8 275.5 363.9 239.8 319.7 240C275.5 240.2 239.8 276.1 240 320.3C240.2 364.5 276.1 400.2 320.3 400z" />
    </svg>
  );
};

const SessionSVG = ({ className = `` }: Partial<IconTypes>) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.001 2.001C5.922 2.001 1.998 6.923 1.998 12.001C1.998 17.078 5.922 21.999 12.001 21.999C18.078 21.999 22.001 17.078 22.001 12.001C22.001 6.923 18.078 2.001 12.001 2.001ZM12.001 20.001C7.021 20.001 3.998 16.979 3.998 12.001C3.998 7.021 7.021 3.998 12.001 3.998C16.979 3.998 20.001 7.021 20.001 12.001C20.001 16.979 16.979 20.001 12.001 20.001Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.001 2.001C5.922 2.001 1.998 6.923 1.998 12.001C1.998 17.078 5.922 21.999 12.001 21.999C18.078 21.999 22.001 17.078 22.001 12.001C22.001 6.923 18.078 2.001 12.001 2.001ZM12.001 20.001C7.021 20.001 3.998 16.979 3.998 12.001C3.998 7.021 7.021 3.998 12.001 3.998C16.979 3.998 20.001 7.021 20.001 12.001C20.001 16.979 16.979 20.001 12.001 20.001Z"
      />
    </svg>
  );
};

function MoneyIcon({ className = `` }: Partial<IconTypes>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 320 512"
      className={className}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={30}
        color="currentColor"
      >
        <path d="M160 0c17.7 0 32 14.3 32 32l0 35.7c1.6 .2 3.1 .4 4.7 .7c.4 .1 .7 .1 1.1 .2l48 8.8c17.4 3.2 28.9 19.9 25.7 37.2s-19.9 28.9-37.2 25.7l-47.5-8.7c-31.3-4.6-58.9-1.5-78.3 6.2s-27.2 18.3-29 28.1c-2 10.7-.5 16.7 1.2 20.4c1.8 3.9 5.5 8.3 12.8 13.2c16.3 10.7 41.3 17.7 73.7 26.3l2.9 .8c28.6 7.6 63.6 16.8 89.6 33.8c14.2 9.3 27.6 21.9 35.9 39.5c8.5 17.9 10.3 37.9 6.4 59.2c-6.9 38-33.1 63.4-65.6 76.7c-13.7 5.6-28.6 9.2-44.4 11l0 33.4c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-34.9c-.4-.1-.9-.1-1.3-.2l-.2 0s0 0 0 0c-24.4-3.8-64.5-14.3-91.5-26.3c-16.1-7.2-23.4-26.1-16.2-42.2s26.1-23.4 42.2-16.2c20.9 9.3 55.3 18.5 75.2 21.6c31.9 4.7 58.2 2 76-5.3c16.9-6.9 24.6-16.9 26.8-28.9c1.9-10.6 .4-16.7-1.3-20.4c-1.9-4-5.6-8.4-13-13.3c-16.4-10.7-41.5-17.7-74-26.3l-2.8-.7s0 0 0 0C119.4 279.3 84.4 270 58.4 253c-14.2-9.3-27.5-22-35.8-39.6c-8.4-17.9-10.1-37.9-6.1-59.2C23.7 116 52.3 91.2 84.8 78.3c13.3-5.3 27.9-8.9 43.2-11L128 32c0-17.7 14.3-32 32-32z"></path>
      </g>
    </svg>
  );
}

function RewardIcon({ className = `` }: Partial<IconTypes>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      className={`lucide lucide-gem-icon lucide-gem`}
    >
      <path d="M10.5 3 8 9l4 13 4-13-2.5-6" />
      <path d="M17 3a2 2 0 0 1 1.6.8l3 4a2 2 0 0 1 .013 2.382l-7.99 10.986a2 2 0 0 1-3.247 0l-7.99-10.986A2 2 0 0 1 2.4 7.8l2.998-3.997A2 2 0 0 1 7 3z" />
      <path d="M2 9h20" />
    </svg>
  );
}

function ActivitiesSVG({ className = `` }: Partial<IconTypes>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_101_10044)">
        <path
          d="M0.75 0.75C3 5.25 1.875 6.375 4.125 8.625C4.125 8.625 6.228 8.625 7.38422 7.60837C6.25955 8.79364 5.63385 10.3661 5.63672 12C5.66156 13.6713 6.34291 15.2657 7.53355 16.4387C8.7242 17.6118 10.3286 18.2694 12 18.2694C13.6714 18.2694 15.2758 17.6118 16.4664 16.4387C17.6571 15.2657 18.3384 13.6713 18.3633 12C18.3683 10.3845 17.7587 8.82766 16.6582 7.64503C17.8228 8.62486 19.875 8.625 19.875 8.625C22.125 6.375 21 5.25 23.25 0.75C18.75 3 17.625 1.875 15.375 4.125C15.375 4.125 15.3752 6.21563 16.3828 7.37405C15.2028 6.25231 13.6378 5.62546 12.0098 5.62246C10.3817 5.61947 8.8144 6.24054 7.63031 7.35792C8.62439 6.19641 8.625 4.125 8.625 4.125C6.375 1.875 5.25 3 0.75 0.75ZM4.125 15.375C1.875 17.625 3 18.75 0.75 23.25C5.25 21 6.375 22.125 8.625 19.875C8.625 19.875 8.625 17.625 7.5 16.5C6.375 15.375 4.125 15.375 4.125 15.375ZM19.875 15.375C19.875 15.375 17.625 15.375 16.5 16.5C15.375 17.625 15.375 19.875 15.375 19.875C17.625 22.125 18.75 21 23.25 23.25C21 18.75 22.125 17.625 19.875 15.375Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_101_10044">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export const SidebarIcon = {
  RidesSVG,
  TaxisSVG,
  RequestDriverSVG,
  HomeSvg,
  PlaceSVG,
  UsersSvg,
  BookingSvg,
  EventSvg,
  OffersSvg,
  PacksSvg,
  CategoriesSvg,
  ServiceCategoriesSVG,
  NotificationsSvg,
  MessagesWhatsappSvg,
  PartnersSvg,
  CitiesSvg,
  InspectorsSvg,
  NewsletterSvg,
  ArrowsRightLeftIcon,
  PayoutsSvg,
  TranslationsSvg,
  DriversSvg,
  SettingsSvg,
  LogoutIcon,
  AdvertisementSVG,
  SatistiquesIconSVG,
  ActivitiesSVG,
  SettingsSVG,
  MoneyIcon,
  SpecialZoneSvg,
  RewardIcon,
  SessionSVG,
};
